export default __webpack_public_path__ + "static/media/image2.53015b4a.png";